import { useEffect } from "react";

export default function TogglePasswordBehaviour() {
  useEffect(() => {

    // --- PASSWORD TOGGLE ---
    document.querySelectorAll(".hide-show-eye").forEach((eyeIcon) => {
      if (eyeIcon.dataset.bound === "true") return;
      eyeIcon.dataset.bound = "true";

      const container = eyeIcon.closest(".icon-input");
      const input = container.querySelector(".password-field");
      const showEye = eyeIcon.querySelector(".show-eye");
      const hideEye = eyeIcon.querySelector(".hide-eye");

      if (!input || !showEye || !hideEye) return;

      // initial state
      showEye.style.display = "none";
      hideEye.style.display = "block";

      eyeIcon.addEventListener("click", () => {
        const isHidden = input.type === "password";
        input.type = isHidden ? "text" : "password";
        showEye.style.display = isHidden ? "block" : "none";
        hideEye.style.display = isHidden ? "none" : "block";
      });
    });

    // --- FORM VALIDATION ---
    const emailInput = document.getElementById("emailInput");
    const emailField = document.getElementById("emailField");
    const form = document.getElementById("signinForm");

    if (!form) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?[0-9]{7,15}$/;

    function validateEmailOrPhone(value) {
      return emailRegex.test(value) || phoneRegex.test(value);
    }

    // ✅ Submit listener
    form.addEventListener("submit", function (e) {
      const value = emailInput.value.trim();

      // only prevent submit if value exists but invalid
      if (value !== "" && !validateEmailOrPhone(value)) {
        e.preventDefault();
        emailField.classList.add("error");
      } else {
        emailField.classList.remove("error");
        // ✅ allow natural form submission to Django
      }
    });

    // ✅ Live validation
    emailInput.addEventListener("input", function () {
      const value = this.value.trim();
      if (validateEmailOrPhone(value)) {
        emailField.classList.remove("error");
      }
    });

  }, []);

  return null;
}